import { useEffect, useState, useCallback } from "react";
import { Dropdown, Form, OverlayTrigger, Popover } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { isEmpty } from "lodash";
import CatalogueService from "../../../../../../service/CatalogueService";
import {
    MissionStore,
    setFilterPayloadDeviceList,
    setIsNewPayloadCatalog,
    setPayloadSliderFalse,
    setPayloadSliderTrue,
} from "../../../../../../store/MissionSlice";
import {
    calculatePayloadUsage,
    calculate_Total_AOP_Usage,
    truncateNumber,
    uuidv4,
    showToastMessage,
    isInvalidMinMaxRange,
} from "../../../../../../utils/commonFunctions";
import {
    ConfigredImaging,
    ConfiguredComm,
    ConfiguredReq,
    PayloadsList,
} from "../../../Stepper.constants";
import InputSlider from "./InputSlider";
import ConfirmationDialog from "../../../../../CommonComponents/confirmation_dialog/ConfirmationDialog";
import NewPayloadCatalog from "../NewPayloadCatalog";

const MIN_MAX_VALIDATION_MSG = 'Minimum value cannot exceed Maximum value';

const SecondStep = ({
    payloadCatalouge,
    setPayloadCatalouge,
    setPayloadType,
    setPayloadSubType,
    satPayloads,
    pyloadSrc,
    payloadType,
    setUserInput,
    userInput,
    payloadSubType,
    selectedBands,
    setSelectedBands,
    setLoading,
    setSelectedPayload,
    selectedPayload,
    setPayloadSliderData,
    satellieteDeta
}) => {
    const dispatch = useDispatch();
    const filterPayloadDeviceList = useSelector(
        (state: { mission: MissionStore }) => state.mission.filterPayloadDeviceList
    );
    const isNewPayloadCatalog = useSelector(
        (state: { mission: MissionStore }) => state.mission.isNewPayloadCatalog
    );
    const isEditPayload = useSelector(
        (state: { mission: MissionStore }) => state.mission.isEditPayload
    );
    const EditPayloadData: any = useSelector(
        (state: { mission: MissionStore }) => state.mission.EditPayloadData
    );
    const isPayloadSlider = useSelector(
        (state: { mission: MissionStore }) => state.mission.isPayloadSlider
    );

    const [showBtnGroup, setShowBtnGroup] = useState("");

    const [openInputSlider, setOpenInputSlider] = useState(false);
    const [allPayloadDevices, setAllPayloadDevices] = useState<any[]>([]);
    const [previousFilterdList, setPreviousFilterdList] = useState<any[]>([]);
    const [orbitDuration, setOrbitDuration] = useState(0);

    const [filteringInput, setFilteringInput] = useState<any>({
        weight: {
            min: "",
            max: "",
        },
        size: {
            min: "",
            max: "",
        },
        gsd: {
            min: "",
            max: "",
        },
        swath: {
            min: "",
            max: "",
        },
        "Data Rate": "",
        "Number of Beams": "",
    });

    const [selectedDeviceId, setSelectedDeviceId] = useState<string>("");
    const [deleteCatalouge, setDeleteCatalouge] = useState<any>(null);
    const [openDeleteModel, setOpenDeleteModal] = useState<any>(false);

    const [configImg, setConfigImg] = useState<ConfigredImaging>(
        new ConfigredImaging()
    );
    const [configComm, setConfigComm] = useState<ConfiguredComm>(
        new ConfiguredComm()
    );

    const calculateOrbitDuration = () => {
        const EARTH_RADIUS_KM = 6378.137; // km
        const MU = 3.986e14; // m^3/s^2
        if (satellieteDeta) {
            const altitudeKm = satellieteDeta?.referenceOrbitParameters?.altitude;
            const inclinationDeg = satellieteDeta?.referenceOrbitParameters?.inclination;
            const r_km = EARTH_RADIUS_KM + altitudeKm;
            const a_m = r_km * 1000;
            const periodSec = 2 * Math.PI * Math.sqrt(Math.pow(a_m, 3) / MU);
            let periodMin = periodSec / 60;
            // Bias toward "nice" LEO style values
            periodMin = Math.round(periodMin / 5) * 5; // snap to nearest 5 min
            setOrbitDuration(periodMin);
        }

    }

    const getAllCatalogs = () => {
        const response = CatalogueService.getCatalogue("Payload Server", "Payload");
        response
            ?.then((data) => {
                if (data.data) {
                    let filter_device = data.data.filter(
                        (device) =>
                            payloadCatalouge ===
                            device?.["component_specific_attributes"]?.["payloadType"]
                    );
                    reset_filtering_inputs();
                    setAllPayloadDevices(filter_device);
                    setPayloadType("");
                    setPayloadSubType("");
                    setSelectedBands([]);
                    setConfigComm(new ConfiguredComm());
                    setConfigImg(new ConfigredImaging());
                    dispatch(setFilterPayloadDeviceList(filter_device));
                    setPreviousFilterdList(filter_device);
                    if (isNewPayloadCatalog) {
                        dispatch(setIsNewPayloadCatalog(false));
                    }
                    setLoading(false);
                }
            })
            .catch((err) => {
                console.log(err);
                setLoading(false);
            });
    };

    useEffect(() => {
        if (payloadCatalouge !== "" && !isNewPayloadCatalog) {
            getAllCatalogs();
        }
    }, [payloadCatalouge]);

    useEffect(() => {
        if (satellieteDeta) {
            calculateOrbitDuration();
        }
    }, [satellieteDeta]);

    // Handle clicks outside payload cards to deselect payload
    const handleClickOutside = useCallback((event: MouseEvent) => {
        const target = event.target as Element;
        if (
            !target.closest('.payload-cards-container') && // Don't deselect when clicking on payload cards
            !target.closest('.bg-right-slider') && // Don't deselect when clicking on InputSlider
            !target.closest('.right-slider-box') // Don't deselect when clicking on PayloadSlider summary
        ) {
            setSelectedDeviceId("");
            setOpenInputSlider(false);
        }
    }, [setSelectedDeviceId, setOpenInputSlider]);

    useEffect(() => {
        if (!selectedDeviceId) return;

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [selectedDeviceId, handleClickOutside]);

    const reset_filtering_inputs = () => {
        setFilteringInput({
            weight: {
                min: "",
                max: "",
            },
            size: {
                min: "",
                max: "",
            },
            gsd: {
                min: "",
                max: "",
            },
            swath: {
                min: "",
                max: "",
            },
            "Data Rate": "",
            "Number of Beams": "",
        });
    };

    useEffect(() => {
        if (isEditPayload) {
            const atmosData = EditPayloadData?.atmosData;
            const userData = EditPayloadData?.userData;
            setPayloadCatalouge(
                payloadCatalouge === ""
                    ? atmosData?.["component_specific_attributes"]?.["payloadType"]
                    : payloadCatalouge
            );
            setSelectedDeviceId(atmosData?.["uniqueId"]);
            setOpenInputSlider(
                payloadCatalouge ===
                    atmosData?.["component_specific_attributes"]?.["payloadType"]
                    ? true
                    : false
            );

            if (
                atmosData?.["component_specific_attributes"]?.["payloadType"] ===
                "Earth Observation"
            ) {
                setConfigImg(
                    userData?.["typeSpecificParams"]
                        ? userData?.["typeSpecificParams"]
                        : {}
                );
            } else if (
                atmosData?.["component_specific_attributes"]?.["payloadType"] ===
                "Communication"
            ) {
                setConfigComm(userData?.["typeSpecificParams"]);
            }
            let payload = {
                atmosData: atmosData,
                numUnits: userData?.["numUnits"],
                downlinkDatasize: userData?.["downlinkDatasize"],
                time_per_orbit: userData?.["time_per_orbit"],
                AltMeasureAccuracy: userData?.["AltMeasureAccuracy"],
                interfaces: userData?.["selected_interfaces"],
                gpioCount: userData?.["gpio_count"],
                payloadImageSrc: atmosData?.["src"],
                payloadName: userData?.["payload_name"],
                isContinuousLoad: userData?.['isContinuousLoad'] || false
            };
            setUserInput(payload);
            onSelectDevices(payload);
            setLoading(false);
        }
    }, [isEditPayload, payloadCatalouge]);

    const handleMinMaxBlur = (field: 'gsd' | 'swath' | 'weight' | 'size') => {
        const min = filteringInput?.[field]?.min;
        const max = filteringInput?.[field]?.max;
        if (isInvalidMinMaxRange(min, max)) {
            showToastMessage('error', MIN_MAX_VALIDATION_MSG);
            setFilteringInput((prev) => ({
                ...prev,
                [field]: {
                    ...prev?.[field],
                    max: '',
                },
            }));
            // Re-apply filters with max cleared so min filter still applies to the list
            const filteredList = applyFiltersToDeviceList(previousFilterdList, {
                [field]: { min: min ?? '', max: '' },
            });
            dispatch(setFilterPayloadDeviceList(filteredList));
        }
    };

    type MinMaxRange = { min: string; max: string };

    const applyMinMaxRangeFilter = (
        list: any[],
        range: MinMaxRange | undefined,
        getValue: (device: any) => number
    ): any[] => {
        if (!range || isInvalidMinMaxRange(range.min, range.max)) return list;
        let result = list;
        if (range.min !== '') result = result.filter((d) => getValue(d) >= +range.min);
        if (range.max !== '' && +range.max >= +(range.min || 0)) result = result.filter((d) => getValue(d) <= +range.max);
        return result;
    };

    // Apply filters only when range is valid (min <= max). Invalid range = skip that filter, don't reset list.
    const applyFiltersToDeviceList = (
        baseList: any[],
        opts: {
            gsd?: MinMaxRange;
            swath?: MinMaxRange;
            weight?: MinMaxRange;
            size?: MinMaxRange;
        }
    ): any[] => {
        let result = baseList || [];
        const gsd = opts.gsd ?? filteringInput?.gsd;
        const swath = opts.swath ?? filteringInput?.swath;
        const weight = opts.weight ?? filteringInput?.weight;
        const size = opts.size ?? filteringInput?.size;

        result = applyMinMaxRangeFilter(
            result,
            gsd,
            (d) => +d?.['component_specific_attributes']?.['typeSpecificParams']?.['GSD']
        );
        result = applyMinMaxRangeFilter(
            result,
            swath,
            (d) => +d?.['component_specific_attributes']?.['typeSpecificParams']?.['Swath']
        );
        result = applyMinMaxRangeFilter(result, weight, (d) => +d?.['weight_in_gms'] / 1000);
        result = applyMinMaxRangeFilter(result, size, (d) => +d?.['product-cookie']?.['Size']);

        if (payloadCatalouge === "Communication") {
            if (filteringInput?.["Data Rate"] !== "") result = result.filter((d) => +d?.["component_specific_attributes"]?.["typeSpecificParams"]?.["Data Rate"] >= +filteringInput?.["Data Rate"]);
            if (filteringInput?.["Number of Beams"] !== "") result = result.filter((d) => +d?.["component_specific_attributes"]?.["typeSpecificParams"]?.["Number of Beams"] >= +filteringInput?.["Number of Beams"]);
        }
        return result;
    };

    const deleteUserCatalouge = (payload) => {
        const catalougeId = payload?.["uniqueId"];
        setLoading(true);
        CatalogueService.deleteCatalogue(catalougeId)
            ?.then((response) => {
                let remainingList = filterPayloadDeviceList?.filter(
                    (payload) => payload?.["uniqueId"] !== catalougeId
                );
                if (selectedPayload?.["atmosData"]?.["uniqueId"] === catalougeId) {
                    setSelectedPayload({});
                    setPayloadSliderData({});
                }
                dispatch(setPayloadSliderFalse());
                dispatch(setFilterPayloadDeviceList(remainingList));
                getAllCatalogs();
                showToastMessage("success", "Payload Device deleted successfully");
            })
            .catch((err) => {
                console.log("Something went wrong");
                setLoading(false);
            });
    };

    const onSelectDevices = (data) => {
        let default_sequence = [];
        let userConfig: any = new ConfiguredReq();
        let typeConfig: any = {};
        userConfig = {
            numUnits: 0,
            downlinkDatasize: data?.["downlinkDatasize"]
                ? +data?.["downlinkDatasize"]
                : 1,
            time_per_orbit: data?.["time_per_orbit"] ? +data?.["time_per_orbit"] : 5,
            AltMeasureAccuracy: data?.["AltMeasureAccuracy"]
                ? +data?.["AltMeasureAccuracy"]
                : 1,
            isContinuousLoad: data?.['isContinuousLoad'] || false,
        };
        if (
            data?.["atmosData"]?.["component_specific_attributes"]?.[
            "payloadType"
            ] === "Communication"
        ) {
            typeConfig = configComm;
        }
        let time_per_orbit = data?.["time_per_orbit"]
            ? data?.["time_per_orbit"]
            : "5";
        let dutyCycle: number = truncateNumber(Number(time_per_orbit / 90), 2); // ------> dutycycle = timeperOrbit/90
        let aop: number = truncateNumber(
            Number(data?.["atmosData"]?.["max_power_consumption_in_watts"]) *
            dutyCycle,
            2
        ); // -----> aop = maxPower * dutyCycle
        let peakSolarPower: number = truncateNumber((aop / 0.8) * 2 * 2, 2); //----->PeakSolarPower = aop * efficiency(80%) * eclipse Offset(2) * 2

        const atmosData = {
            ...data?.["atmosData"],
            src: data?.["payloadImageSrc"],
        };
        if (atmosData.sequences && atmosData.sequences.length > 0) {
            let atmos_sequence = atmosData.sequences.map((seq) => {
                return {
                    seqName: seq?.["seqName"],
                    seqPowerRequirements: seq?.["seqPowerRequirements"],
                    stagedTCId: seq?.["stagedTCId"],
                    seqId: uuidv4(),
                    mode: seq?.["mode"],
                    datarate: seq?.["datarate"],
                };
            });
            default_sequence = atmos_sequence;
        }
        let newPayload = {
            atmosData: atmosData,
            userData: {
                ...userConfig,
                id:
                    isEditPayload &&
                        atmosData?.["uniqueId"] ===
                        EditPayloadData?.["atmosData"]?.["uniqueId"]
                        ? EditPayloadData?.["userData"]?.["id"]
                        : uuidv4(),
                payload_name:
                    data?.["payloadName"] === "" || data?.["payloadName"] === undefined
                        ? data?.["atmosData"]?.["name"]
                        : data?.["payloadName"],
                aop: aop,
                typeSpecificParams: {},
                selected_interfaces: data?.["interfaces"],
                dutyCycle: truncateNumber(Number(dutyCycle * 100), 1),
                peak_solar_power: peakSolarPower,
                gpio_count: Number(data?.["gpioCount"]) || 0,
            },
            sequences:
                isEditPayload &&
                    atmosData?.["uniqueId"] ===
                    EditPayloadData?.["atmosData"]?.["uniqueId"] &&
                    EditPayloadData?.["sequences"]
                    ? EditPayloadData?.["sequences"]
                    : default_sequence,
            metrics:
                isEditPayload &&
                    atmosData?.["uniqueId"] === EditPayloadData?.["atmosData"]?.["uniqueId"]
                    ? EditPayloadData?.["metrics"]
                    : data?.["atmosData"]?.["metrics"],
        };

        if (satPayloads?.length > 0 && !isEditPayload) {
            calculatePayloadUsage([...satPayloads, newPayload], dispatch);
            calculate_Total_AOP_Usage([...satPayloads, newPayload], [], dispatch);
        } else if (satPayloads?.length > 0 && isEditPayload) {
            let filterPayloads;
            if (EditPayloadData?.["userData"]) {
                filterPayloads = satPayloads?.filter((payload) =>
                    payload?.userData
                        ? payload?.userData?.id !== EditPayloadData?.["userData"]?.["id"]
                        : payload?.userData?.id !== EditPayloadData?.["userData"]?.["id"]
                );
            }

            calculatePayloadUsage([...filterPayloads, newPayload], dispatch);
            calculate_Total_AOP_Usage([...filterPayloads, newPayload], [], dispatch);
        } else {
            calculatePayloadUsage([newPayload], dispatch);
            calculate_Total_AOP_Usage([newPayload], [], dispatch);
        }
        setSelectedPayload(newPayload);
        setPayloadSliderData(newPayload);
    };

    const onSelectPayload = (data) => {
        if (selectedDeviceId === data?.["uniqueId"]) return
        setSelectedDeviceId(data?.["uniqueId"]);
        const updatedUserInput = {
            ...userInput,
            atmosData: data,
            time_per_orbit: "5",
            AltMeasureAccuracy: "1",
            isContinuousLoad: false,
            downlinkDatasize: "1",
            payloadName: data?.["name"].includes("/")
                ? `${data?.["name"].replace("/", "-")}`
                : data?.["name"],
            interfaces: data?.["component_specific_attributes"]?.["interfaces"],
            gpioCount: data?.["component_specific_attributes"]?.["interfaces"].includes("GPIO") ? 1 : "",
            payloadImageSrc: pyloadSrc,
        }
        setUserInput(updatedUserInput);
        onSelectDevices(updatedUserInput);
    };

    const resetPayloadFilter = () => {
        reset_filtering_inputs();
        setPayloadType("");
        setPayloadSubType("");
        setSelectedBands([]);
        setConfigComm(new ConfiguredComm());
        setConfigImg(new ConfigredImaging());
        dispatch(setFilterPayloadDeviceList(allPayloadDevices));
        setPreviousFilterdList(allPayloadDevices);
    };

    return (
        <div className="d-flex w-100 h-90" onClick={() => setShowBtnGroup("")}>
            {!isNewPayloadCatalog && (
                <div className="d-flex h-90 w-100">
                    <div className="d-flex w-25 py-4 rounded-3">
                        <div className="w-100 h-100 overflow-y-auto px-5 d-flex flex-column gap-3">
                            {payloadCatalouge === "Earth Observation" && (
                                <div className="d-flex w-100 flex-column gap-3">
                                    <div className="form-row justify-content-between group-radio">
                                        <div className="d-flex flex-column">
                                            <h3 className="mb-3 color-text color-atmos-secondary">
                                                {payloadCatalouge}
                                            </h3>
                                            <label className="color-text mb-3">Payload Type</label>
                                            <div className="w-100 d-flex gap-2 flex-wrap">
                                                {["Imaging", "Radar", "AIS"].map((val) => (
                                                    <button
                                                        key={val}
                                                        className={`btn btn-payload py-3 px-5 position-relative ${payloadType === val
                                                            ? "btn-primary"
                                                            : "btn-outline-primary"
                                                            }`}
                                                        onClick={() => {
                                                            if (payloadType === val) {
                                                                setPayloadType("");
                                                                dispatch(
                                                                    setFilterPayloadDeviceList(allPayloadDevices)
                                                                );
                                                                setPreviousFilterdList(allPayloadDevices);
                                                                reset_filtering_inputs();
                                                            } else {
                                                                setPayloadType(val);
                                                                setPayloadSubType("");
                                                                let filter_device = allPayloadDevices?.filter(
                                                                    (device) =>
                                                                        device?.["component_specific_attributes"]?.[
                                                                        "payloadSubType"
                                                                        ] === val
                                                                );
                                                                dispatch(
                                                                    setFilterPayloadDeviceList(filter_device)
                                                                );
                                                                if (filter_device.length > 0) {
                                                                    setPreviousFilterdList(filter_device);
                                                                    reset_filtering_inputs();
                                                                }
                                                            }
                                                            setConfigImg(new ConfigredImaging());
                                                        }}
                                                    >
                                                        {val.split(" ")[0]}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    {payloadType === "Imaging" && (
                                        <div className="form-row justify-content-between group-radio">
                                            <div className="d-flex flex-column">
                                                <label className="color-text mb-3">
                                                    Payload SubType
                                                </label>
                                                <div className="w-100 d-flex gap-2 flex-wrap">
                                                    {[
                                                        "MX / Multispectral",
                                                        "Thermal IR",
                                                        "SWIR",
                                                        "Hyperspectral",
                                                    ].map((val) => (
                                                        <button
                                                            key={val}
                                                            className={`btn btn-payload py-3 px-4 position-relative ${payloadSubType === val
                                                                ? "btn-primary"
                                                                : "btn-outline-primary"
                                                                }`}
                                                            onClick={() => {
                                                                if (payloadSubType === val) {
                                                                    setPayloadSubType("");
                                                                    let filter_device = allPayloadDevices?.filter(
                                                                        (device) =>
                                                                            device?.[
                                                                            "component_specific_attributes"
                                                                            ]?.["payloadSubType"] === payloadType
                                                                    );
                                                                    dispatch(
                                                                        setFilterPayloadDeviceList(filter_device)
                                                                    );
                                                                    if (filter_device.length > 0) {
                                                                        setPreviousFilterdList(filter_device);
                                                                        reset_filtering_inputs();
                                                                    }
                                                                } else {
                                                                    setPayloadSubType(val);
                                                                    let filter_device = allPayloadDevices?.filter(
                                                                        (device) =>
                                                                            device?.[
                                                                            "component_specific_attributes"
                                                                            ]?.["payloadDetails"] === val
                                                                    );
                                                                    dispatch(
                                                                        setFilterPayloadDeviceList(filter_device)
                                                                    );
                                                                    if (filter_device.length > 0) {
                                                                        setPreviousFilterdList(filter_device);
                                                                        reset_filtering_inputs();
                                                                    }
                                                                }
                                                                setConfigImg(new ConfigredImaging());
                                                            }}
                                                        >
                                                            {val === "MX / Multispectral"
                                                                ? "Multispectral"
                                                                : val}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {payloadType === "Radar" && (
                                        <div className="form-row justify-content-between group-radio">
                                            <div className="d-flex flex-column">
                                                <label className="color-text mb-3">
                                                    Payload SubType
                                                </label>
                                                <div className="w-100 d-flex gap-2 flex-wrap">
                                                    {["Microwave", "SAR", "LIDAR"].map((val) => (
                                                        <button
                                                            key={val}
                                                            className={`btn btn-payload py-3 px-4 position-relative ${payloadSubType === val
                                                                ? "btn-primary"
                                                                : "btn-outline-primary"
                                                                }`}
                                                            onClick={() => {
                                                                if (payloadSubType === val) {
                                                                    setPayloadSubType("");
                                                                    let filter_device = allPayloadDevices?.filter(
                                                                        (device) =>
                                                                            device?.[
                                                                            "component_specific_attributes"
                                                                            ]?.["payloadSubType"] === payloadType
                                                                    );
                                                                    dispatch(
                                                                        setFilterPayloadDeviceList(filter_device)
                                                                    );
                                                                    if (filter_device.length > 0) {
                                                                        setPreviousFilterdList(filter_device);
                                                                        reset_filtering_inputs();
                                                                    }
                                                                } else {
                                                                    setPayloadSubType(val);
                                                                    let filter_device = allPayloadDevices?.filter(
                                                                        (device) =>
                                                                            device?.[
                                                                            "component_specific_attributes"
                                                                            ]?.["payloadDetails"] === val
                                                                    );
                                                                    dispatch(
                                                                        setFilterPayloadDeviceList(filter_device)
                                                                    );
                                                                    if (filter_device.length > 0) {
                                                                        setPreviousFilterdList(filter_device);
                                                                        reset_filtering_inputs();
                                                                    }
                                                                }
                                                                setConfigImg(new ConfigredImaging());
                                                            }}
                                                        >
                                                            {val.split(" ")[0]}
                                                        </button>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {(payloadType === "Imaging" || payloadType === "") && (
                                        <div className="d-flex flex-column w-100">
                                            <Form.Label className="color-text mb-2">
                                                Ground Sampling Distance (m)
                                            </Form.Label>
                                            <div className="w-100 d-flex align-items-center justify-content-between gap-1">
                                                <div className="w-50 d-flex flex-column gap-2">
                                                    <span className="fs-13 color-text">Minimum</span>
                                                    <Form.Control
                                                        required={
                                                            payloadType === "Imaging" &&
                                                            payloadSubType === "MX / Multispectral"
                                                        }
                                                        type="text"
                                                        placeholder="Minimum GSD "
                                                        value={filteringInput?.["gsd"]?.["min"]}
                                                        onBlur={() => handleMinMaxBlur('gsd')}
                                                        onKeyDown={(e) => {
                                                            if (e.keyCode === 13) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(event: any) => {
                                                            event.preventDefault();
                                                            if (
                                                                !isNaN(event.target.value) &&
                                                                event.target.value.length <= 5
                                                            ) {
                                                                const newMin = event.target.value;
                                                                const newMax = filteringInput?.["gsd"]?.["max"];
                                                                setFilteringInput({
                                                                    ...filteringInput,
                                                                    gsd: {
                                                                        min: newMin,
                                                                        max: newMax,
                                                                    },
                                                                });
                                                                let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                                    gsd: { min: newMin, max: newMax },
                                                                });
                                                                dispatch(
                                                                    setFilterPayloadDeviceList(filter_device)
                                                                );
                                                            } else if (event.target.value.length > 5) {
                                                                showToastMessage(
                                                                    "info",
                                                                    "Maximum 5 digits allowed"
                                                                );
                                                            }
                                                        }}
                                                    ></Form.Control>
                                                </div>
                                                <i className="fe fe-minus mt-5 color_history"></i>
                                                <div className="w-50 d-flex flex-column gap-2">
                                                    <span className="fs-13">Maximum</span>
                                                    <Form.Control
                                                        required={
                                                            payloadType === "Imaging" &&
                                                            payloadSubType === "MX / Multispectral"
                                                        }
                                                        type="text"
                                                        placeholder="Maximum GSD"
                                                        value={filteringInput?.["gsd"]?.["max"]}
                                                        onBlur={() => handleMinMaxBlur('gsd')}
                                                        onKeyDown={(e) => {
                                                            if (e.keyCode === 13) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(event: any) => {
                                                            event.preventDefault();
                                                            if (
                                                                !isNaN(event.target.value) &&
                                                                event.target.value.length <= 5
                                                            ) {
                                                                const newMax = event.target.value;
                                                                const newMin = filteringInput?.["gsd"]?.["min"];
                                                                setFilteringInput({
                                                                    ...filteringInput,
                                                                    gsd: {
                                                                        min: newMin,
                                                                        max: newMax,
                                                                    },
                                                                });
                                                                let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                                    gsd: { min: newMin, max: newMax },
                                                                });
                                                                dispatch(
                                                                    setFilterPayloadDeviceList(filter_device)
                                                                );
                                                            } else if (event.target.value.length > 5) {
                                                                showToastMessage(
                                                                    "info",
                                                                    "Maximum 5 digits allowed"
                                                                );
                                                            }
                                                        }}
                                                    ></Form.Control>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {(payloadType === "Imaging" || payloadType === "") && (
                                        <div className="d-flex flex-column w-100">
                                            <Form.Label className="color-text mb-2">
                                                Swath (km)
                                            </Form.Label>
                                            <div className="w-100 d-flex align-items-center justify-content-between gap-1">
                                                <div className="w-50 d-flex flex-column gap-2">
                                                    <span className="fs-13 color-text">Minimum</span>
                                                    <Form.Control
                                                        required={
                                                            payloadType === "Imaging" &&
                                                            payloadSubType === "MX / Multispectral"
                                                        }
                                                        type="text"
                                                        placeholder="Minimum swath"
                                                        value={filteringInput?.["swath"]?.["min"]}
                                                        onBlur={() => handleMinMaxBlur('swath')}
                                                        onKeyDown={(e) => {
                                                            if (e.keyCode === 13) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(event: any) => {
                                                            event.preventDefault();
                                                            if (
                                                                !isNaN(event.target.value) &&
                                                                event.target.value.length <= 5
                                                            ) {
                                                                const newMin = event.target.value;
                                                                const newMax = filteringInput?.["swath"]?.["max"];
                                                                setFilteringInput({
                                                                    ...filteringInput,
                                                                    swath: {
                                                                        min: newMin,
                                                                        max: newMax,
                                                                    },
                                                                });
                                                                let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                                    swath: { min: newMin, max: newMax },
                                                                });
                                                                dispatch(
                                                                    setFilterPayloadDeviceList(filter_device)
                                                                );
                                                            } else if (event.target.value.length > 5) {
                                                                showToastMessage(
                                                                    "info",
                                                                    "Maximum 5 digits allowed"
                                                                );
                                                            }
                                                        }}
                                                    ></Form.Control>
                                                </div>
                                                <i className="fe fe-minus mt-5 color_history"></i>
                                                <div className="w-50 d-flex flex-column gap-2">
                                                    <span className="fs-13 color-text">Maximum</span>
                                                    <Form.Control
                                                        required={
                                                            payloadType === "Imaging" &&
                                                            payloadSubType === "MX / Multispectral"
                                                        }
                                                        type="text"
                                                        placeholder="Maximum swath"
                                                        value={filteringInput?.["swath"]?.["max"]}
                                                        onBlur={() => handleMinMaxBlur('swath')}
                                                        onKeyDown={(e) => {
                                                            if (e.keyCode === 13) {
                                                                e.preventDefault();
                                                            }
                                                        }}
                                                        onChange={(event: any) => {
                                                            event.preventDefault();
                                                            if (
                                                                !isNaN(event.target.value) &&
                                                                event.target.value.length <= 5
                                                            ) {
                                                                const newMax = event.target.value;
                                                                const newMin = filteringInput?.["swath"]?.["min"];
                                                                setFilteringInput({
                                                                    ...filteringInput,
                                                                    swath: {
                                                                        min: newMin,
                                                                        max: newMax,
                                                                    },
                                                                });
                                                                let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                                    swath: { min: newMin, max: newMax },
                                                                });
                                                                dispatch(
                                                                    setFilterPayloadDeviceList(filter_device)
                                                                );
                                                            } else if (event.target.value.length > 5) {
                                                                showToastMessage(
                                                                    "info",
                                                                    "Maximum 5 digits allowed"
                                                                );
                                                            }
                                                        }}
                                                    ></Form.Control>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {payloadCatalouge === "Communication" && (
                                <div className="w-100 d-flex flex-column gap-3">
                                    <div className="form-row group-radio d-flex flex-column">
                                        <h3 className="mb-3 color-text">{payloadCatalouge}</h3>
                                        <label className="color-text mb-3">Payload Type</label>
                                        <div className="w-100 d-flex gap-3 flex-wrap">
                                            {["RF", "Optical"].map((val) => (
                                                <button
                                                    key={val}
                                                    className={`btn btn-payload py-3 position-relative ${payloadType === val
                                                        ? "btn-primary"
                                                        : "btn-outline-primary"
                                                        }`}
                                                    onClick={() => {
                                                        if (payloadType === val) {
                                                            setPayloadType("");
                                                            dispatch(
                                                                setFilterPayloadDeviceList(allPayloadDevices)
                                                            );
                                                            setSelectedBands([]);
                                                            setPreviousFilterdList(allPayloadDevices);
                                                            reset_filtering_inputs();
                                                        } else {
                                                            setPayloadType(val);
                                                            setPayloadSubType("");
                                                            let filter_device = allPayloadDevices?.filter(
                                                                (device) =>
                                                                    device?.["component_specific_attributes"]?.[
                                                                    "payloadSubType"
                                                                    ] === val
                                                            );
                                                            dispatch(
                                                                setFilterPayloadDeviceList(filter_device)
                                                            );
                                                            if (filter_device.length > 0) {
                                                                setPreviousFilterdList(filter_device);
                                                                reset_filtering_inputs();
                                                            }
                                                        }
                                                        setSelectedBands([]);
                                                        setConfigComm(new ConfiguredComm());
                                                    }}
                                                >
                                                    {val}
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    {payloadType === "RF" && (
                                        <div className="form-row w-100 d-flex flex-column ">
                                            <Form.Label className="color-text">
                                                Frequency Bands
                                            </Form.Label>
                                            <div className="w-100 d-flex flex-wrap gap-3 mt-2">
                                                {[
                                                    "S Band",
                                                    "V Band",
                                                    "E Band",
                                                    "Ka Band",
                                                    "Ku Band",
                                                ].map((btn) => (
                                                    <button
                                                        key={btn}
                                                        className={`btn btn-payload position-relative ${selectedBands.includes(btn)
                                                            ? "btn-primary"
                                                            : "btn-outline-primary"
                                                            }`}
                                                        onClick={() => {
                                                            if (selectedBands.includes(btn)) {
                                                                let selected_bands = selectedBands.filter(
                                                                    (band) => band !== btn
                                                                );
                                                                setSelectedBands(selected_bands);

                                                                let filter_device: any[] = [];
                                                                if (selected_bands.length > 0) {
                                                                    allPayloadDevices?.filter((device: any) => {
                                                                        if (
                                                                            device?.[
                                                                            "component_specific_attributes"
                                                                            ]?.["typeSpecificParams"]?.[
                                                                            "Frequency Bands"
                                                                            ] &&
                                                                            selected_bands.length > 0
                                                                        ) {
                                                                            selected_bands.map((band) => {
                                                                                if (
                                                                                    device?.[
                                                                                        "component_specific_attributes"
                                                                                    ]?.["typeSpecificParams"]?.[
                                                                                        "Frequency Bands"
                                                                                    ].includes(band)
                                                                                ) {
                                                                                    if (!filter_device.includes(device)) {
                                                                                        filter_device.push(device);
                                                                                    }
                                                                                }
                                                                            });
                                                                        }
                                                                    });
                                                                    dispatch(
                                                                        setFilterPayloadDeviceList(filter_device)
                                                                    );
                                                                    if (filter_device.length > 0) {
                                                                        setPreviousFilterdList(filter_device);
                                                                        reset_filtering_inputs();
                                                                    }
                                                                } else {
                                                                    let filter_device = allPayloadDevices?.filter(
                                                                        (device) =>
                                                                            device?.[
                                                                            "component_specific_attributes"
                                                                            ]?.["payloadSubType"] === payloadType
                                                                    );
                                                                    dispatch(
                                                                        setFilterPayloadDeviceList(filter_device)
                                                                    );
                                                                    if (filter_device.length > 0) {
                                                                        setPreviousFilterdList(filter_device);
                                                                        reset_filtering_inputs();
                                                                    }
                                                                }
                                                            } else {
                                                                let selected_bands = [...selectedBands, btn];
                                                                setSelectedBands(selected_bands);

                                                                let filter_device: any[] = [];

                                                                allPayloadDevices?.map((device: any) => {
                                                                    if (
                                                                        device?.["component_specific_attributes"]?.[
                                                                        "typeSpecificParams"
                                                                        ]?.["Frequency Bands"] &&
                                                                        selected_bands.length > 0
                                                                    ) {
                                                                        selected_bands.map((band) => {
                                                                            if (
                                                                                device?.[
                                                                                    "component_specific_attributes"
                                                                                ]?.["typeSpecificParams"]?.[
                                                                                    "Frequency Bands"
                                                                                ].includes(band)
                                                                            ) {
                                                                                if (!filter_device.includes(device)) {
                                                                                    filter_device.push(device);
                                                                                }
                                                                            }
                                                                        });
                                                                    }
                                                                });
                                                                dispatch(
                                                                    setFilterPayloadDeviceList(filter_device)
                                                                );
                                                                if (filter_device.length > 0) {
                                                                    setPreviousFilterdList(filter_device);
                                                                    reset_filtering_inputs();
                                                                }
                                                            }
                                                            setConfigComm(new ConfiguredComm());
                                                        }}
                                                    >
                                                        {btn}
                                                    </button>
                                                ))}
                                            </div>
                                        </div>
                                    )}

                                    {(payloadType === "RF" || payloadType === "") && (
                                        <div className="d-flex flex-column w-100">
                                            <Form.Label className="color-text mb-3">
                                                Data Rate (Mbps)
                                            </Form.Label>
                                            <Form.Control
                                                required={payloadType === "RF"}
                                                type="text"
                                                placeholder="Enter data rate (Mbps)"
                                                value={filteringInput?.["Data Rate"]}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(event: any) => {
                                                    event.preventDefault();
                                                    const value = event.target.value;
                                                    if (!isNaN(value) && value.length <= 5) {
                                                        setFilteringInput({
                                                            ...filteringInput,
                                                            "Data Rate": value,
                                                        });
                                                        let filter_device = previousFilterdList?.filter(
                                                            (device) =>
                                                                +device?.["component_specific_attributes"]?.[
                                                                "typeSpecificParams"
                                                                ]?.["Data Rate"] >= +value
                                                        );
                                                        filter_device =
                                                            filteringInput?.["Number of Beams"] !== ""
                                                                ? filter_device?.filter(
                                                                    (device) =>
                                                                        +device?.[
                                                                        "component_specific_attributes"
                                                                        ]?.["typeSpecificParams"]?.[
                                                                        "Number of Beams"
                                                                        ] >= +filteringInput?.["Number of Beams"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["weight"]?.["min"] !== ""
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["weight_in_gms"] / 1000 >=
                                                                        +filteringInput?.["weight"]?.["min"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["weight"]?.["max"] !== "" &&
                                                                +filteringInput?.["weight"]?.["max"] >=
                                                                +filteringInput?.["weight"]?.["min"]
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["weight_in_gms"] / 1000 <=
                                                                        +filteringInput?.["weight"]?.["max"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["size"]?.["min"] !== ""
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["product-cookie"]?.["Size"] >=
                                                                        +filteringInput?.["size"]?.["min"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["size"]?.["max"] !== "" &&
                                                                +filteringInput?.["size"]?.["max"] >=
                                                                +filteringInput?.["size"]?.["min"]
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["product-cookie"]?.["Size"] <=
                                                                        +filteringInput?.["size"]?.["max"]
                                                                )
                                                                : filter_device;
                                                        dispatch(setFilterPayloadDeviceList(filter_device));
                                                    } else if (value.length > 5) {
                                                        showToastMessage(
                                                            "info",
                                                            "Maximum 5 digits allowed"
                                                        );
                                                    }
                                                    if (isEmpty(value)) {
                                                        dispatch(
                                                            setFilterPayloadDeviceList(previousFilterdList)
                                                        );
                                                        return;
                                                    }
                                                }}
                                            ></Form.Control>
                                        </div>
                                    )}
                                    {(payloadType === "RF" || payloadType === "") && (
                                        <div className="d-flex flex-column w-100">
                                            <Form.Label className="color-text mb-3">
                                                Number of Beams
                                            </Form.Label>
                                            <Form.Control
                                                required={payloadType === "RF"}
                                                type="text"
                                                placeholder="Enter number of beams"
                                                value={filteringInput?.["Number of Beams"]}
                                                onKeyDown={(e) => {
                                                    if (e.keyCode === 13) {
                                                        e.preventDefault();
                                                    }
                                                }}
                                                onChange={(event: any) => {
                                                    event.preventDefault();
                                                    const value = event.target.value;
                                                    if (!isNaN(value) && value.length <= 5) {
                                                        setFilteringInput({
                                                            ...filteringInput,
                                                            "Number of Beams": value,
                                                        });
                                                        let filter_device = previousFilterdList?.filter(
                                                            (device) =>
                                                                +device?.["component_specific_attributes"]?.[
                                                                "typeSpecificParams"
                                                                ]?.["Number of Beams"] >= +value
                                                        );
                                                        filter_device =
                                                            filteringInput?.["Data Rate"] !== ""
                                                                ? filter_device?.filter(
                                                                    (device) =>
                                                                        +device?.[
                                                                        "component_specific_attributes"
                                                                        ]?.["typeSpecificParams"]?.[
                                                                        "Data Rate"
                                                                        ] >= +filteringInput?.["Data Rate"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["weight"]?.["min"] !== ""
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["weight_in_gms"] / 1000 >=
                                                                        +filteringInput?.["weight"]?.["min"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["weight"]?.["max"] !== "" &&
                                                                +filteringInput?.["weight"]?.["max"] >=
                                                                +filteringInput?.["weight"]?.["min"]
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["weight_in_gms"] / 1000 <=
                                                                        +filteringInput?.["weight"]?.["max"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["size"]?.["min"] !== ""
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["product-cookie"]?.["Size"] >=
                                                                        +filteringInput?.["size"]?.["min"]
                                                                )
                                                                : filter_device;
                                                        filter_device =
                                                            filteringInput?.["size"]?.["max"] !== "" &&
                                                                +filteringInput?.["size"]?.["max"] >=
                                                                +filteringInput?.["size"]?.["min"]
                                                                ? filter_device.filter(
                                                                    (device) =>
                                                                        +device?.["product-cookie"]?.["Size"] <=
                                                                        +filteringInput?.["size"]?.["max"]
                                                                )
                                                                : filter_device;
                                                        dispatch(setFilterPayloadDeviceList(filter_device));
                                                    } else if (event.target.value.length > 5) {
                                                        showToastMessage(
                                                            "info",
                                                            "Maximum 5 digits allowed"
                                                        );
                                                    }
                                                    if (isEmpty(value)) {
                                                        dispatch(
                                                            setFilterPayloadDeviceList(previousFilterdList)
                                                        );
                                                        return;
                                                    }
                                                }}
                                            ></Form.Control>
                                        </div>
                                    )}
                                </div>
                            )}

                            <div className="d-flex flex-column w-100">
                                <Form.Label className="color-text mb-2">Mass (kg)</Form.Label>
                                <div className="d-flex align-items-center justify-content-between gap-1 w-100">
                                    <div className="w-50 d-flex flex-column gap-2">
                                        <span className="fs-13 color-text">Minimum</span>
                                        <Form.Control
                                            value={filteringInput?.weight?.min}
                                            type="text"
                                            placeholder="Minimum mass"
                                            onBlur={() => handleMinMaxBlur('weight')}
                                            onKeyDown={(e) => {
                                                if (e.keyCode === 13) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(event: any) => {
                                                event.preventDefault();
                                                if (
                                                    !isNaN(event.target.value) &&
                                                    event.target.value.length <= 5
                                                ) {
                                                    const newMin = event.target.value;
                                                    const newMax = filteringInput?.weight?.max;
                                                    setFilteringInput({
                                                        ...filteringInput,
                                                        weight: {
                                                            min: newMin,
                                                            max: newMax,
                                                        },
                                                    });
                                                    let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                        weight: { min: newMin, max: newMax },
                                                    });
                                                    dispatch(setFilterPayloadDeviceList(filter_device));
                                                } else if (event.target.value.length > 5) {
                                                    showToastMessage("info", "Maximum 5 digits allowed");
                                                }
                                            }}
                                        ></Form.Control>
                                    </div>
                                    <i className="fe fe-minus mt-6 color_history"></i>
                                    <div className="w-50 d-flex flex-column gap-2">
                                        <span className="fs-13 color-text">Maximum</span>
                                        <Form.Control
                                            value={filteringInput?.weight?.max}
                                            type="text"
                                            placeholder="Maximum mass"
                                            onBlur={() => handleMinMaxBlur('weight')}
                                            onKeyDown={(e) => {
                                                if (e.keyCode === 13) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(event: any) => {
                                                event.preventDefault();
                                                if (
                                                    !isNaN(event.target.value) &&
                                                    event.target.value.length <= 5
                                                ) {
                                                    const newMax = event.target.value;
                                                    const newMin = filteringInput?.["weight"]?.["min"];
                                                    setFilteringInput({
                                                        ...filteringInput,
                                                        weight: {
                                                            min: newMin,
                                                            max: newMax,
                                                        },
                                                    });
                                                    let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                        weight: { min: newMin, max: newMax },
                                                    });
                                                    dispatch(setFilterPayloadDeviceList(filter_device));
                                                } else if (event.target.value.length > 5) {
                                                    showToastMessage("info", "Maximum 5 digits allowed");
                                                }
                                            }}
                                        ></Form.Control>
                                    </div>
                                </div>
                            </div>

                            <div className="d-flex flex-column w-100">
                                <Form.Label className="color-text mb-2">Size (U)</Form.Label>
                                <div className="d-flex align-items-center justify-content-between gap-1 w-100">
                                    <div className="w-50 d-flex flex-column gap-2">
                                        <span className="fs-13 color-text">Minimum </span>
                                        <Form.Control
                                            value={filteringInput?.size?.min}
                                            type="text"
                                            placeholder="Minimum size"
                                            onBlur={() => handleMinMaxBlur('size')}
                                            onKeyDown={(e) => {
                                                if (e.keyCode === 13) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(event: any) => {
                                                event.preventDefault();
                                                if (
                                                    !isNaN(event.target.value) &&
                                                    event.target.value.length <= 5
                                                ) {
                                                    const newMin = event.target.value;
                                                    const newMax = filteringInput?.size?.max;
                                                    setFilteringInput({
                                                        ...filteringInput,
                                                        size: {
                                                            min: newMin,
                                                            max: newMax,
                                                        },
                                                    });
                                                    let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                        size: { min: newMin, max: newMax },
                                                    });
                                                    dispatch(setFilterPayloadDeviceList(filter_device));
                                                } else if (event.target.value.length > 5) {
                                                    showToastMessage("info", "Maximum 5 digits allowed");
                                                }
                                            }}
                                        ></Form.Control>
                                    </div>
                                    <i className="fe fe-minus mt-5 color_history"></i>
                                    <div className="w-50 d-flex flex-column gap-2">
                                        <span className="fs-13 color-text">Maximum </span>
                                        <Form.Control
                                            value={filteringInput?.size?.max}
                                            type="text"
                                            placeholder="Maximum size"
                                            onBlur={() => handleMinMaxBlur('size')}
                                            onKeyDown={(e) => {
                                                if (e.keyCode === 13) {
                                                    e.preventDefault();
                                                }
                                            }}
                                            onChange={(event: any) => {
                                                event.preventDefault();
                                                if (
                                                    !isNaN(event.target.value) &&
                                                    event.target.value.length <= 5
                                                ) {
                                                    const newMax = event.target.value;
                                                    const newMin = filteringInput?.["size"]?.["min"];
                                                    setFilteringInput({
                                                        ...filteringInput,
                                                        size: {
                                                            min: newMin,
                                                            max: newMax,
                                                        },
                                                    });
                                                    let filter_device = applyFiltersToDeviceList(previousFilterdList, {
                                                        size: { min: newMin, max: newMax },
                                                    });
                                                    dispatch(setFilterPayloadDeviceList(filter_device));
                                                } else if (event.target.value.length > 5) {
                                                    showToastMessage("info", "Maximum 5 digits allowed");
                                                }
                                            }}
                                        ></Form.Control>
                                    </div>
                                </div>
                            </div>
                            <div className="w-90 d-flex justify-content-center mt-3">
                                <button
                                    className="btn btn-outline-primary px-8 fs-18"
                                    onClick={resetPayloadFilter}
                                >
                                    Reset
                                </button>
                            </div>
                            <div className="p-3"></div>
                        </div>
                    </div>

                    <div className="d-flex w-75 py-4 h-100 position-relative">
                        <div
                            className={`d-flex flex-column ${openInputSlider ? "opacity-75" : "opacity-100"
                                } h-100 position-relative transition w-100 overflow-y-auto`}
                        >
                            <div className={`d-flex flex-wrap w-100 ps-5 payload-cards-container`}>
                                {filterPayloadDeviceList?.length > 0 &&
                                    filterPayloadDeviceList.map((data: any, i) => {
                                        let gpio_interface = data?.[
                                            "component_specific_attributes"
                                        ]?.["interfaces"].filter((item) => item === "GPIO");
                                        let filter_interfaces = data?.[
                                            "component_specific_attributes"
                                        ]?.["interfaces"].filter((item) => item !== "GPIO");
                                        let all_interfaces = [
                                            ...filter_interfaces,
                                            ...gpio_interface,
                                        ];

                                        let weight = data?.["weight_in_gms"];
                                        return (
                                            <div
                                                className={
                                                    data?.["uniqueId"] === selectedDeviceId
                                                        ? "common-card-box active done"
                                                        : "common-card-box"
                                                }
                                                key={i}
                                                onClick={() => {
                                                    if (selectedDeviceId !== data?.["uniqueId"]) {
                                                        onSelectPayload(data);
                                                    }
                                                    setOpenInputSlider(true);
                                                }}
                                            >
                                                <div className="common-card-header d-flex justify-content-between align-items-center">
                                                    <div
                                                        className="W-90 text-truncate"
                                                        title={data?.["name"]}
                                                    >
                                                        <h4 className="mb-2 text-truncate">
                                                            {data?.["name"]}
                                                        </h4>
                                                    </div>
                                                    <div
                                                        className="btn-list more-button"
                                                        onClick={(e) => e.stopPropagation()}
                                                    >
                                                        <Dropdown
                                                            drop={"end"}
                                                            show={showBtnGroup === data?.["uniqueId"]}
                                                        >
                                                            <Dropdown.Toggle
                                                                variant="transparent text-white fs-20"
                                                                onClick={(e) => {
                                                                    e.stopPropagation();
                                                                    if (showBtnGroup === data?.["uniqueId"]) {
                                                                        setShowBtnGroup("");
                                                                    } else {
                                                                        setShowBtnGroup(data?.["uniqueId"]);
                                                                    }
                                                                }}
                                                            >
                                                                <i className="fe fe-more-vertical"></i>
                                                            </Dropdown.Toggle>
                                                            <Dropdown.Menu>
                                                                <Dropdown.Item
                                                                    eventKey="0"
                                                                    onClick={() => {
                                                                        if (selectedDeviceId !== data?.["uniqueId"]) {
                                                                            onSelectPayload(data);
                                                                        }
                                                                        setOpenInputSlider(false);
                                                                        dispatch(setPayloadSliderTrue());
                                                                        setShowBtnGroup("");
                                                                    }}
                                                                >
                                                                    Summary
                                                                </Dropdown.Item>
                                                                {data?.["owner-org"] !== "System" && (
                                                                    <Dropdown.Item
                                                                        eventKey="1"
                                                                        onClick={() => {
                                                                            setDeleteCatalouge(data);
                                                                            setOpenDeleteModal(true);
                                                                            setShowBtnGroup("");
                                                                        }}
                                                                    >
                                                                        Delete
                                                                    </Dropdown.Item>
                                                                )}
                                                            </Dropdown.Menu>
                                                        </Dropdown>
                                                    </div>
                                                </div>
                                                <div className="common-card-content">
                                                    <div className="d-flex flex-wrap">
                                                        <div className="stats-alpha">
                                                            <strong>
                                                                {data?.["product-cookie"]?.["Size"] + " U"}
                                                            </strong>
                                                            <span>Size</span>
                                                        </div>
                                                        <div className="stats-alpha">
                                                            <strong>
                                                                {weight > 999
                                                                    ? weight / 1000 + " kg"
                                                                    : weight + " g"}
                                                            </strong>
                                                            <span>Mass</span>
                                                        </div>
                                                        <div className="stats-alpha">
                                                            <strong>
                                                                {data?.["max_power_consumption_in_watts"] +
                                                                    " W"}
                                                            </strong>
                                                            <span>Peak Power</span>
                                                        </div>
                                                        <div className="stats-alpha">
                                                            <strong>
                                                                {data?.["average_power_consumption"] + " W"}
                                                            </strong>
                                                            <span>Average Power</span>
                                                        </div>
                                                        {data?.['product-cookie']?.['Coding Scheme'] && <div className="stats-alpha">
                                                            <strong>
                                                                {data?.['product-cookie']?.['Coding Scheme']}
                                                            </strong>
                                                            <span>Coding Scheme</span>
                                                        </div>}
                                                        {data?.['product-cookie']?.['Gain'] && <div className="stats-alpha">
                                                            <strong>
                                                                {data?.['product-cookie']?.['Gain']}
                                                            </strong>
                                                            <span>Gain</span>
                                                        </div>}
                                                        {data?.['product-cookie']?.['Modulation'] && <div className="stats-alpha">
                                                            <strong>
                                                                {data?.['product-cookie']?.['Modulation']}
                                                            </strong>
                                                            <span>Modulation</span>
                                                        </div>}
                                                        {data?.['product-cookie']?.['Polarization'] && <div className="stats-alpha">
                                                            <strong>
                                                                {data?.['product-cookie']?.['Polarization']}
                                                            </strong>
                                                            <span>Polarization</span>
                                                        </div>}
                                                        {data?.['product-cookie']?.['Tx channels'] && <div className="stats-alpha">
                                                            <strong>
                                                                {data?.['product-cookie']?.['Tx channels']}
                                                            </strong>
                                                            <span>TX Channel</span>
                                                        </div>}
                                                        {data?.["component_specific_attributes"]?.[
                                                            "typeSpecificParams"
                                                        ] &&
                                                            Object.keys(
                                                                data?.["component_specific_attributes"]?.[
                                                                "typeSpecificParams"
                                                                ]
                                                            )?.length > 0 &&
                                                            Object.keys(
                                                                data?.["component_specific_attributes"]?.[
                                                                "typeSpecificParams"
                                                                ]
                                                            ).map((k) => {
                                                                if (k !== "Frequency Bands") {
                                                                    return (
                                                                        <div key={k} className="stats-alpha">
                                                                            <div className="text-truncate">
                                                                                <strong title={data?.["component_specific_attributes"]?.["typeSpecificParams"]?.[k]}>
                                                                                    {k === "GSD" || k === "MS GSD" ?
                                                                                        data?.["component_specific_attributes"]?.["typeSpecificParams"]?.[k] + " m" :
                                                                                        k === "Swath" ? data?.["component_specific_attributes"]?.["typeSpecificParams"]?.[k] + " km" :
                                                                                            k === "Data Rate" ? data?.["component_specific_attributes"]?.["typeSpecificParams"]?.[k] + " Mbps" :
                                                                                                data?.["component_specific_attributes"]?.["typeSpecificParams"]?.[k]}
                                                                                </strong>
                                                                            </div>
                                                                            <div className="d-flex align-items-center">
                                                                                <span className={(k !== "GSD" && k !== "Swath") ? "text-truncate" : ""}>{k}</span>
                                                                                {(k === "GSD" || k === "Swath") && (
                                                                                    <OverlayTrigger
                                                                                        placement="right"
                                                                                        overlay={
                                                                                            <Popover id="popover-basic">
                                                                                                <Popover.Body>
                                                                                                    <span className="color-text text-center d-flex">
                                                                                                        {k === "GSD"
                                                                                                            ? "@GSD 500km"
                                                                                                            : "@Swath 500km"}
                                                                                                    </span>
                                                                                                </Popover.Body>
                                                                                            </Popover>
                                                                                        }
                                                                                    >
                                                                                        <sup>
                                                                                            <i className="fe fe-info ms-1 fs-12 text-info"></i>
                                                                                        </sup>
                                                                                    </OverlayTrigger>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                }
                                                            })}
                                                        {data?.["component_specific_attributes"]?.[
                                                            "additionalParams"
                                                        ] &&
                                                            Object.keys(
                                                                data?.["component_specific_attributes"]?.[
                                                                "additionalParams"
                                                                ]
                                                            )?.length > 0 &&
                                                            Object.keys(
                                                                data?.["component_specific_attributes"]?.[
                                                                "additionalParams"
                                                                ]
                                                            ).map((k) => {
                                                                return (
                                                                    <div key={k} className="stats-alpha">
                                                                        <div className="text-truncate">
                                                                            <strong className="w-90 text-truncate" title={data?.[
                                                                                "component_specific_attributes"
                                                                            ]?.["additionalParams"]?.[k]}>
                                                                                {
                                                                                    data?.[
                                                                                    "component_specific_attributes"
                                                                                    ]?.["additionalParams"]?.[k]
                                                                                }
                                                                            </strong>
                                                                        </div>
                                                                        <div className="d-flex align-items-center">
                                                                            <span title={k} className="text-truncate">
                                                                                {k}
                                                                            </span>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}

                                                        {data?.["component_specific_attributes"]?.[
                                                            "typeSpecificParams"
                                                        ]?.["Frequency Bands"] &&
                                                            data?.["component_specific_attributes"]?.[
                                                                "typeSpecificParams"
                                                            ]?.["Frequency Bands"].length > 0 && (
                                                                <div className="d-flex flex-column mt-3">
                                                                    <div className="d-flex gap-1 w-100 flex-wrap">
                                                                        {data?.["component_specific_attributes"]?.[
                                                                            "typeSpecificParams"
                                                                        ]?.["Frequency Bands"].map((val, i) => {
                                                                            return (
                                                                                <div key={i} className="d-flex gap-1">
                                                                                    <strong>{val}</strong>
                                                                                    <strong>{`${data?.[
                                                                                        "component_specific_attributes"
                                                                                    ]?.["typeSpecificParams"]?.[
                                                                                        "Frequency Bands"
                                                                                    ].length !==
                                                                                        i + 1
                                                                                        ? "|"
                                                                                        : ""
                                                                                        }`}</strong>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                    </div>
                                                                    <span>Frequency Bands</span>
                                                                </div>
                                                            )}
                                                    </div>
                                                </div>
                                                <div className="common-card-footer mb-2">
                                                    <span className="footer-title">Interfaces</span>
                                                    <div className="d-flex w-100 flex-wrap">
                                                        {data?.["component_specific_attributes"]?.[
                                                            "interfaces"
                                                        ]?.length > 0 &&
                                                            all_interfaces.map((val, i) => {
                                                                return (
                                                                    <div className="d-flex" key={i}>
                                                                        {val !== "GPIO" && (
                                                                            <span
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    if (
                                                                                        selectedDeviceId ===
                                                                                        data?.["uniqueId"]
                                                                                    ) {
                                                                                        let interfaces: any = [];
                                                                                        if (
                                                                                            userInput?.["interfaces"].length >
                                                                                            1
                                                                                        ) {
                                                                                            if (
                                                                                                userInput?.[
                                                                                                    "interfaces"
                                                                                                ].includes(val)
                                                                                            ) {
                                                                                                interfaces = userInput?.[
                                                                                                    "interfaces"
                                                                                                ].filter(
                                                                                                    (item) => item !== val
                                                                                                );
                                                                                            } else {
                                                                                                interfaces = [
                                                                                                    ...userInput?.["interfaces"],
                                                                                                    val,
                                                                                                ];
                                                                                            }
                                                                                        } else {
                                                                                            if (
                                                                                                userInput?.["interfaces"][0] !==
                                                                                                val
                                                                                            ) {
                                                                                                interfaces = [
                                                                                                    ...userInput?.["interfaces"],
                                                                                                    val,
                                                                                                ];
                                                                                            } else {
                                                                                                interfaces =
                                                                                                    userInput?.["interfaces"];
                                                                                            }
                                                                                        }
                                                                                        setUserInput({
                                                                                            ...userInput,
                                                                                            interfaces: interfaces,
                                                                                            gpioCount: userInput?.[
                                                                                                "interfaces"
                                                                                            ].includes("GPIO")
                                                                                                ? userInput?.["gpioCount"]
                                                                                                : "",
                                                                                        });
                                                                                        onSelectDevices({
                                                                                            ...userInput,
                                                                                            atmosData: data,
                                                                                            interfaces: interfaces,
                                                                                            gpioCount: userInput?.[
                                                                                                "interfaces"
                                                                                            ].includes("GPIO")
                                                                                                ? userInput?.["gpioCount"]
                                                                                                : "",
                                                                                        });
                                                                                    }
                                                                                }}
                                                                                className={
                                                                                    selectedDeviceId ===
                                                                                        data?.["uniqueId"]
                                                                                        ? data?.[
                                                                                            "component_specific_attributes"
                                                                                        ]?.["interfaces"].length > 1
                                                                                            ? userInput?.["interfaces"] &&
                                                                                                userInput?.[
                                                                                                    "interfaces"
                                                                                                ].includes(val)
                                                                                                ? "badge-pill active mb-2"
                                                                                                : "badge-pill mb-2"
                                                                                            : "badge-pill-active mb-2"
                                                                                        : "badge-pill-inactive mb-2"
                                                                                }
                                                                                key={i}
                                                                            >
                                                                                {val}
                                                                            </span>
                                                                        )}
                                                                        {val === "GPIO" && (
                                                                            <div className="d-flex me-2">
                                                                                <span
                                                                                    className={
                                                                                        selectedDeviceId !==
                                                                                            data?.["uniqueId"]
                                                                                            ? "badge-pill-inactive"
                                                                                            : userInput?.["interfaces"] &&
                                                                                                userInput?.[
                                                                                                    "interfaces"
                                                                                                ].includes("GPIO")
                                                                                                ? "badge-pill active "
                                                                                                : "badge-pill"
                                                                                    }
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        if (
                                                                                            selectedDeviceId ===
                                                                                            data?.["uniqueId"]
                                                                                        ) {
                                                                                            let interfaces: any =
                                                                                                userInput?.["interfaces"];
                                                                                            let gpioCount: any = userInput?.[
                                                                                                "interfaces"
                                                                                            ].includes("GPIO")
                                                                                                ? userInput?.["gpioCount"]
                                                                                                : "";

                                                                                            if (interfaces.includes("GPIO")) {
                                                                                                if (interfaces.length > 1) {
                                                                                                    interfaces =
                                                                                                        interfaces.filter(
                                                                                                            (item) => item !== "GPIO"
                                                                                                        );
                                                                                                    gpioCount = "";
                                                                                                }
                                                                                            } else {
                                                                                                interfaces = [
                                                                                                    ...interfaces,
                                                                                                    "GPIO",
                                                                                                ];
                                                                                                gpioCount = 1;
                                                                                            }
                                                                                            setUserInput({
                                                                                                ...userInput,
                                                                                                interfaces: interfaces,
                                                                                                gpioCount: gpioCount,
                                                                                            });
                                                                                            onSelectDevices({
                                                                                                ...userInput,
                                                                                                atmosData: data,
                                                                                                interfaces: interfaces,
                                                                                                gpioCount: gpioCount,
                                                                                            });
                                                                                        }
                                                                                    }}
                                                                                >
                                                                                    GPIO
                                                                                </span>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                            </div>
                        </div>
                        {openInputSlider &&
                            <InputSlider
                                toggle={() => {
                                    setOpenInputSlider(!openInputSlider);
                                }}
                                openInputSlider={openInputSlider}
                                onSelectDevices={onSelectDevices}
                                userInput={userInput}
                                setUserInput={setUserInput}
                                orbitDuration={orbitDuration}
                                payloadType={payloadCatalouge}
                            />
                        }
                    </div>
                </div>
            )}
            {!isNewPayloadCatalog &&
                <div className={`py-2 px-3 position-absolute top-65px d-flex gap-2 align-items-center cursor-pointer right-40 z-9 bg-black border rounded-2`}
                    onClick={() => {
                        if (isPayloadSlider) {
                            dispatch(setPayloadSliderFalse());
                        }
                        dispatch(setIsNewPayloadCatalog(true));
                    }}
                >
                    <i className="fe fe-plus fs-20"></i>
                    Payload Device
                </div>
            }

            <ConfirmationDialog
                type="delete"
                open={openDeleteModel ? true : false}
                title={`Delete Payload?`}
                description={`Deleting ${deleteCatalouge?.["name"]} will permanently remove it from the database, and it cannot be restored once deleted.`}
                onCancel={() => {
                    setOpenDeleteModal(false);
                    setDeleteCatalouge(null);
                }}
                onConfirm={() => {
                    deleteUserCatalouge(deleteCatalouge);
                    setOpenDeleteModal(false);
                    setDeleteCatalouge(null);
                }}
                confirm_button_text={`Delete`}
            />

            {isNewPayloadCatalog && (
                <NewPayloadCatalog
                    payloadsList={PayloadsList}
                    onSelectPayloadCatalogType={(data) => {
                        setPayloadCatalouge(data?.type);
                    }}
                    payloadType={payloadCatalouge}
                    payloadSubtype={payloadType}
                    setPayloadSubType={setPayloadType}
                    imgPayloadDetails={payloadSubType}
                    setImgPayloadDetails={setPayloadSubType}
                    configImg={configImg}
                    setConfigImg={setConfigImg}
                    configComm={configComm}
                    radarPayloadDetails={payloadSubType}
                    setRadarPayloadDetails={setPayloadSubType}
                    handleFreqBands={(band) => {
                        if (selectedBands.includes(band)) {
                            setSelectedBands(selectedBands.filter((band) => band !== band));
                        } else {
                            setSelectedBands([...selectedBands, band]);
                        }
                    }}
                    setConfigComm={setConfigComm}
                    selectedBands={selectedBands}
                    getAllCatalogs={getAllCatalogs}
                />
            )}
        </div>
    );
};

export default SecondStep;
